import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { JobTypeaheadComponent } from './JobTypeahead.component';

@NgModule({
    imports: [CommonModule, FormsModule, CoreUiModule],
    declarations: [JobTypeaheadComponent],
    exports: [JobTypeaheadComponent],
    providers: []
})
export class JobTypeaheadModule {}
